import { useState, useCallback, useRef, useEffect } from 'react';

import { trackOneSignalEvent } from '../../../utils/onesignal';

import StepByStepForm from './StepByStepForm/StepByStepForm';
import JsonForm from './JsonForm/JsonForm';

import { type IFormData } from '../../../modules/shared/pageProps/formData/@interfaces';
import { type ICategoryTreeRecord } from '../../../modules/budget/transformations/form/@interfaces';

import styles from './CategoryForm.module.scss';
interface ICategoryFormProps extends IFormData {
  className?: string;
  rootCategoryName?: string;
}

const CategoryForm = ({
  categoryTree,
  formContent,
  className,
}: ICategoryFormProps) => {
  const formRef = useRef(null);

  const [category, setCategory] = useState(() => {
    if (categoryTree.children) {
      return null;
    }

    return categoryTree;
  });

  const handleOnSelectedItem = useCallback((item: ICategoryTreeRecord) => {
    setCategory(item);
  }, []);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = '/js/newrelic.js';
    script.async = true;
    script.type = 'text/javascript';
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
      delete window.NREUM;
      delete window.newrelic;
    };
  }, []);

  useEffect(() => {
    const formName = categoryTree?.slug;
    const formCategory = categoryTree?.slug?.split('/')[0];
    const formSubCategory = categoryTree.slug?.split('/').slice(1).join('/');
    const formRoute = category
      ? `https://www.getninjas.com.br/${category.slug}`
      : `https://www.getninjas.com.br/${categoryTree.slug}`;

    trackOneSignalEvent('formulario_comecado', {
      formName: formName,
      formCategory: formCategory,
      formSubCategory: formSubCategory || '',
      formRoute: formRoute,
    });
  }, []);

  return (
    <div
      id="form"
      className={`category-form ${styles['category-form']} ${className}`}
      tabIndex={-1}
      ref={formRef}
    >
      <div className={styles['category-form__content']}>
        {!category ? (
          <StepByStepForm
            ref={formRef}
            categoryTree={categoryTree}
            onSelectedItem={handleOnSelectedItem}
          />
        ) : (
          <JsonForm category={category} formContent={formContent} />
        )}
      </div>
      <div
        className={`${styles['category-form__deadline-info']} category-form__deadline-info`}
      >
        Orçamentos em até 60 minutos
      </div>
    </div>
  );
};

export default CategoryForm;
